import { delayWhileVisible } from './common'

declare global {
  interface Window {
    // facebook pixel
    fbq: (
      command: 'track' | 'init' | 'trackCustom',
      event: string,
      data?: unknown,
      options?: { eventID: string },
    ) => void
  }
}

type ScrollTracker = {
  maxScrollPercent: number
  cleanup: () => void
}

function initializeScrollTracking(): ScrollTracker {
  let maxScrollPercent = 0

  const scrollListener = () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop
    const scrollHeight =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight
    const scrollPercent = Math.round((scrollTop / scrollHeight) * 100)
    maxScrollPercent = Math.max(maxScrollPercent, scrollPercent)
  }

  window.addEventListener('scroll', scrollListener)

  return {
    get maxScrollPercent() {
      return maxScrollPercent
    },
    cleanup: () => window.removeEventListener('scroll', scrollListener),
  }
}

/**
 * Sends an event to Facebook Pixel after 3000ms have elapsed or the page is hidden.
 * Event data includes the maximum scroll percentage of the page.
 */
export function delayedTrackFacebookPixel(pageName: string, eventID: string) {
  const scrollTracker = initializeScrollTracking()

  delayWhileVisible(() => {
    window.fbq(
      'trackCustom',
      pageName,
      { value: scrollTracker.maxScrollPercent },
      { eventID },
    )
    scrollTracker.cleanup()
  }, 3000)
}
